import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { GlobalService } from 'src/app/services/global.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ManagerCardComponent } from '../_components/advisor-card/manager-card/manager-card.component';

@Component({
    selector: 'app-managers-list',
    templateUrl: './managers-list.component.html',
    styleUrls: ['./managers-list.component.scss'],
    imports: [CommonModule,RouterModule,ManagerCardComponent]
})
export class ManagersListComponent implements OnInit {

  title = "Investing for Catholics Executive Managers.";

  managers = [];

  constructor(private dataservice: DataServiceService, private seoservice: SeoService, private meta: Meta, private globalservice: GlobalService, private cdr: ChangeDetectorRef) { 

    this.dataservice.getManager("?$filter=fullName in ("+globalservice.management.map(x=> {return "'"+x.fullName+"'"})+")").subscribe(resp => {
      resp = resp.map( x => { 
        x.imageUrl?(x.imageUrl = x.imageUrl.replace("329x461", "270x378")):(null); 
        return x });
  
     this.managers = resp;


     //Custom ordering
     this.managers.splice(3, 0, {fullName:"John Brunson", titles: ["Marketing and Research Associate"], imageUrl: "https://services.ifa.com/art/images/3502_512x512_c_john-brunson.png"});
     const shareen:any[] = this.managers.splice(6,1);
     this.managers.splice(4, 0, shareen[0]);
     this.cdr.detectChanges();
    })

  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholics advisors, ifc advisors, catholic financial advisors'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Financial Advisors.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
